<footer class="c-footer c-gp-footer">
	<div class="wrapper">
		<div class="container-fluid container-mw">
			<div class="row block-main">
				<div class="col-xs-12 col-sm-4 main-left">
					<div class="block-list" style="padding: 0;">
						<div class="title-copy op-64">&copy; globalping.io, 2022 - {{date.getFullYear()}}</div>

					</div>
				</div>

				<div class="col-xs-12 col-sm-8 main-right">
					<div class="main-right-container">
						<div class="block-list" style="padding: 0;">
							<div class="row list-primary list-small-row">
								<div class="col-sm-12">
									<ul>
										<li><a href="/about-us">About</a></li>
										<li><a href="/sponsors">Our Sponsors</a></li>
										<li><a href="/terms">Terms &amp; Policies</a></li>
										<li><a href="mailto:d@globalping.io"> d@globalping.io</a></li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="footer-separator"></div>

			<div class="row block-main">
				<div class="col-xs-12 col-sm-8 main-left">
					<div class="block-list" style="padding: 0;">
						<div class="title-copy-bottom op-64">Integrations</div>

						<div class="row list-primary">
							<div class="col-sm-12">
								<div class="title-copy op-64">Integrations</div>
							</div>
						</div>

						<div class="row list-second list-small-column">
							<div class="col-sm-12">
								<ul>
									<li><a href="/docs/api.globalping.io" class="router-ignore">REST API</a></li>
									<li><a href="/cli">CLI</a></li>
									<li><a href="/slack">Slack App</a></li>
									<li><a href="/discord">Discord App</a></li>
									<li><a href="https://github.com/jsdelivr/globalping-mcp-server" target="_blank">MCP Server <i class="fa fa-external-link" aria-hidden="true"></i></a></li>
								</ul>
							</div>
						</div>
					</div>
				</div>

				<div class="col-xs-12 col-sm-4 main-right">
					<div class="main-right-container">
						<div class="subscribe-header">
							<span class="text-footer-14">Sign up to our newsletter</span>
						</div>
						<form class="form-inline subscribe-content"
							action="https://jsdelivr.us11.list-manage.com/subscribe?u=0c85fe2c9a60310df9a3d6751&id=283887f736"
							method="POST" target="_blank">
							<div class="form-group">
								<input type="email" autocomplete="email" class="form-control" name="MERGE0" id="new-email" placeholder="Enter your e-mail">
							</div>
							<button type="submit" class="btn btn-default semi-bold">Subscribe</button>
						</form>
					</div>
				</div>
			</div>

			<div class="footer-separator"></div>

			<div class="footer-blog-links">
				<div class="footer-blog-links_title op-64">From our Blog</div>

				<div class="footer-blog-links_block">
					{{#each blogLinksData}}
						<a class="router-ignore" target="_blank" href="{{this.url}}">{{this.text}}</a>
					{{/each}}
				</div>
			</div>

			<div class="footer-separator"></div>

			<div class="footer-gp-links">
				{{#each gpLinksData}}
					<div class="footer-gp-links_block">
						{{#each this}}
							<a class="router-ignore" href="{{@shared.serverHost}}{{this.url}}">{{this.text}}</a>
						{{/each}}
					</div>
				{{/each}}
			</div>
		</div>
	</div>
</footer>

<script>
	const http = require('../../assets/js/utils/http');

	component.exports = {
		data () {
			return {
				date: new Date(),
				docInnerHtml: null,
				gpLinksData: [
					[
						{
							text: 'Ping from Europe',
							url: '/network-tools/ping-from-europe',
						},
						{
							text: 'Ping from USA',
							url: '/network-tools/ping-from-united-states',
						},
						{
							text: 'Ping globally',
							url: '/network-tools/ping',
						},
						{
							text: 'Ping from AWS',
							url: '/network-tools/ping-from-amazoncom',
						},
					],
					[
						{
							text: 'Traceroute from Europe',
							url: '/network-tools/traceroute-from-europe',
						},
						{
							text: 'Traceroute from USA',
							url: '/network-tools/traceroute-from-united-states',
						},
						{
							text: 'Traceroute globally',
							url: '/network-tools/traceroute',
						},
						{
							text: 'Traceroute from AWS',
							url: '/network-tools/traceroute-from-amazoncom',
						},
					],
					[
						{
							text: 'DNS/dig resolve from Europe',
							url: '/network-tools/dns-from-europe',
						},
						{
							text: 'DNS/dig resolve from USA',
							url: '/network-tools/dns-from-united-states',
						},
						{
							text: 'DNS/dig resolve globally',
							url: '/network-tools/dns',
						},
						{
							text: 'DNS/dig resolve from AWS',
							url: '/network-tools/dns-from-amazoncom',
						},
					],
					[
						{
							text: 'HTTP/curl from Europe',
							url: '/network-tools/http-from-europe',
						},
						{
							text: 'HTTP/curl from USA',
							url: '/network-tools/http-from-united-states',
						},
						{
							text: 'HTTP/curl globally',
							url: '/network-tools/http',
						},
						{
							text: 'HTTP/curl from AWS',
							url: '/network-tools/http-from-amazoncom',
						},
					],
				],
				blogLinksData: null,
			};
		},
		oninit () {
			if (!Ractive.isServer) {
				http.getGPBlogRss().then((response) => {
					if (response) {
						let document = new window.DOMParser().parseFromString(response, 'text/xml');
						let items = document.documentElement.childNodes[0].getElementsByTagName('item');
						let data = [];

						for (let i = 0; i < items.length; i++) {
							let currItemNodesList = items[i].childNodes;
							let currItemTitle;
							let currItemLink;
							let currItemPubDate;

							for (let k = 0; k < currItemNodesList.length; k++) {
								if (currItemNodesList[k].nodeName === 'title') {
									currItemTitle = currItemNodesList[k].textContent;
								} else if (currItemNodesList[k].nodeName === 'link') {
									currItemLink = currItemNodesList[k].textContent;
								} else if (currItemNodesList[k].nodeName === 'pubDate') {
									currItemPubDate = currItemNodesList[k].textContent;
								}
							}

							data.push({
								text: currItemTitle,
								url: currItemLink,
								date: new Date(currItemPubDate).getTime(),
							});
						}

						data.sort((a, b) => b.date - a.date);

						this.set('blogLinksData', data.slice(0, 5));
					}
				}).catch(() => {});
			}
		},
	};
</script>
